// 搜尋功能診斷與修復
// 將這段程式碼加入到你的 article-search.js 檔案最前面

(function() {
  'use strict';
  
  console.log('===== 搜尋功能診斷開始 =====');
  
  // 等待 DOM 載入
  document.addEventListener('DOMContentLoaded', function() {
    
    // 1. 診斷搜尋按鈕
    console.log('1. 檢查搜尋按鈕...');
    const searchBtn = document.querySelector('.search-icon-btn');
    if (searchBtn) {
      console.log('✓ 找到搜尋按鈕');
      
      // 移除舊的 onclick 屬性，改用 addEventListener
      searchBtn.removeAttribute('onclick');
      
      // 重新綁定點擊事件
      searchBtn.addEventListener('click', function(e) {
        console.log('搜尋按鈕被點擊了！');
        e.preventDefault();
        e.stopPropagation();
        
        const searchContainer = document.getElementById('desktop-search-container');
        if (searchContainer) {
          console.log('切換搜尋容器顯示狀態');
          
          if (searchContainer.style.display === 'none' || searchContainer.style.display === '') {
            searchContainer.style.display = 'block';
            
            // 添加動畫類
            searchContainer.classList.add('search-active');
            
            // 聚焦搜尋輸入框
            setTimeout(() => {
              const searchInput = searchContainer.querySelector('.search-input');
              if (searchInput) {
                searchInput.focus();
                console.log('✓ 搜尋輸入框已聚焦');
              }
            }, 100);
          } else {
            searchContainer.style.display = 'none';
            searchContainer.classList.remove('search-active');
          }
        } else {
          console.error('✗ 找不到搜尋容器 #desktop-search-container');
        }
      });
      
    } else {
      console.error('✗ 找不到搜尋按鈕 .search-icon-btn');
    }
    
    // 2. 檢查搜尋容器
    console.log('2. 檢查搜尋容器...');
    const searchContainer = document.getElementById('desktop-search-container');
    if (searchContainer) {
      console.log('✓ 找到搜尋容器');
      
      // 確保初始狀態是隱藏的
      searchContainer.style.display = 'none';
      
    } else {
      console.error('✗ 找不到搜尋容器');
    }
    
    // 3. 檢查搜尋輸入框
    console.log('3. 檢查搜尋輸入框...');
    const searchInputs = document.querySelectorAll('.search-input');
    console.log(`找到 ${searchInputs.length} 個搜尋輸入框`);
    
    // 4. 檢查搜尋 Snippet
    console.log('4. 檢查搜尋 Snippet...');
    const searchBar = document.querySelector('.article-search-bar');
    if (searchBar) {
      console.log('✓ 找到搜尋欄 snippet');
    } else {
      console.warn('✗ 找不到搜尋欄 snippet，可能需要創建 article-search-bar.liquid');
    }
    
    // 5. 初始化搜尋功能
    initializeSearch();
    
  });
  
  // 搜尋功能初始化
  function initializeSearch() {
    console.log('5. 初始化搜尋功能...');
    
    const searchInputs = document.querySelectorAll('.search-input');
    
    searchInputs.forEach((input, index) => {
      console.log(`設定搜尋輸入框 ${index + 1}`);
      
      let searchTimer = null;
      
      // 輸入事件
      input.addEventListener('input', function(e) {
        const query = e.target.value.trim();
        console.log('輸入內容:', query);
        
        clearTimeout(searchTimer);
        
        if (query.length < 2) {
          hideSuggestions();
          return;
        }
        
        // 防抖處理
        searchTimer = setTimeout(() => {
          performSearch(query);
        }, 300);
      });
      
      // Enter 鍵提交
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          const query = e.target.value.trim();
          if (query) {
            console.log('Enter 鍵提交搜尋:', query);
            window.location.href = `/search?q=${encodeURIComponent(query)}&type=article`;
          }
        }
      });
    });
    
    // 點擊外部關閉搜尋
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.m-article-v2__search, .desktop-search-container')) {
        const searchContainer = document.getElementById('desktop-search-container');
        if (searchContainer && searchContainer.style.display === 'block') {
          searchContainer.style.display = 'none';
          console.log('點擊外部，關閉搜尋');
        }
      }
    });
  }
  
  // 執行搜尋
  async function performSearch(query) {
    console.log('執行搜尋:', query);
    
    const containers = document.querySelectorAll('.search-suggestions, #search-suggestions');
    
    // 顯示載入狀態
    containers.forEach(container => {
      container.innerHTML = '<div style="padding: 10px; color: #666;">搜尋中...</div>';
      container.style.display = 'block';
    });
    
    try {
      // Shopify 搜尋 API
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=5`;
      console.log('搜尋 URL:', url);
      
      const response = await fetch(url);
      const data = await response.json();
      console.log('搜尋結果:', data);
      
      if (data.resources && data.resources.results && data.resources.results.articles) {
        displayResults(data.resources.results.articles, query);
      } else {
        displayNoResults(query);
      }
      
    } catch (error) {
      console.error('搜尋錯誤:', error);
      displayError();
    }
  }
  
  // 顯示搜尋結果
  function displayResults(articles, query) {
    const containers = document.querySelectorAll('.search-suggestions, #search-suggestions');
    
    if (articles.length === 0) {
      displayNoResults(query);
      return;
    }
    
    let html = '<div style="max-height: 300px; overflow-y: auto;">';
    
    articles.forEach(article => {
      html += `
        <a href="${article.url}" style="display: block; padding: 12px; border-bottom: 1px solid #eee; text-decoration: none; color: #333;">
          <div style="font-weight: 500;">${article.title}</div>
          ${article.published_at ? `<div style="font-size: 12px; color: #666; margin-top: 4px;">${new Date(article.published_at).toLocaleDateString('zh-TW')}</div>` : ''}
        </a>
      `;
    });
    
    html += `
      <a href="/search?q=${encodeURIComponent(query)}&type=article" style="display: block; padding: 12px; text-align: center; color: #00AF9A; text-decoration: none;">
        查看所有結果 →
      </a>
    `;
    
    html += '</div>';
    
    containers.forEach(container => {
      container.innerHTML = html;
      container.style.display = 'block';
    });
  }
  
  // 顯示無結果
  function displayNoResults(query) {
    const containers = document.querySelectorAll('.search-suggestions, #search-suggestions');
    containers.forEach(container => {
      container.innerHTML = `
        <div style="padding: 20px; text-align: center; color: #666;">
          找不到「${query}」的相關文章
        </div>
      `;
      container.style.display = 'block';
    });
  }
  
  // 顯示錯誤
  function displayError() {
    const containers = document.querySelectorAll('.search-suggestions, #search-suggestions');
    containers.forEach(container => {
      container.innerHTML = `
        <div style="padding: 20px; text-align: center; color: #999;">
          搜尋功能暫時無法使用
        </div>
      `;
      container.style.display = 'block';
    });
  }
  
  // 隱藏建議
  function hideSuggestions() {
    const containers = document.querySelectorAll('.search-suggestions, #search-suggestions');
    containers.forEach(container => {
      container.style.display = 'none';
    });
  }
  
  console.log('===== 搜尋功能診斷結束 =====');
  
})();